import { render, staticRenderFns } from "./programModfiyPage.vue?vue&type=template&id=69534a6c&scoped=true&"
import script from "./programModfiyPage.vue?vue&type=script&lang=js&"
export * from "./programModfiyPage.vue?vue&type=script&lang=js&"
import style0 from "./programModfiyPage.vue?vue&type=style&index=0&id=69534a6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69534a6c",
  null
  
)

export default component.exports